"use client";

import {
  ComputerDesktopIcon,
  MoonIcon,
  SunIcon,
} from "@heroicons/react/24/outline";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { useTheme } from "next-themes";

export function ThemeToggle() {
  const t = useTranslations("ThemeToggle");
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // recommended https://github.com/pacocoursey/next-themes?tab=readme-ov-file#avoid-hydration-mismatch
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
  }, []);

  const themes = [
    { value: "system", icon: ComputerDesktopIcon, label: t("systemTheme") },
    { value: "light", icon: SunIcon, label: t("lightTheme") },
    { value: "dark", icon: MoonIcon, label: t("darkTheme") },
  ] as const;
  const currentTheme = theme || "system";
  return (
    <div className="inline-flex items-center gap-1 rounded-lg border border-gray-200 bg-zinc-800/50 p-1 dark:border-zinc-800 dark:bg-zinc-900/50">
      {themes.map(({ value, icon: Icon, label }) => {
        // don't select anything until the component is mounted
        const isSelected = mounted ? currentTheme === value : false;
        return (
          <button
            key={value}
            aria-label={label}
            aria-pressed={isSelected}
            className={`relative flex h-8 w-8 items-center justify-center rounded-md transition-all cursor-pointer ${
              isSelected
                ? "bg-zinc-700 dark:bg-zinc-700"
                : "hover:bg-zinc-700/50 dark:hover:bg-zinc-700/50"
            }`}
            onClick={() => setTheme(value)}
            type="button"
          >
            <Icon
              className={`size-5 transition-colors ${
                isSelected ? "text-white" : "text-white/50 hover:text-white/70"
              }`}
            />
            {isSelected && (
              <span className="absolute inset-0 rounded-md ring-1 ring-inset ring-white/20" />
            )}
          </button>
        );
      })}
    </div>
  );
}
